import startCase from 'lodash/startCase';

import { RelationshipType } from '../../../../../../graphql';

const relationshipTypeValues: RelationshipType[] = Object.values(RelationshipType);

export const relationshipTypeOptions: { label: string; value: RelationshipType }[] =
  relationshipTypeValues.map(value => ({
    value,
    label: startCase(value.toLowerCase()),
  }));
